import React from 'react'
import PropTypes from 'prop-types'
import { device, SmallText, space, color } from '@ticketswap/solar'
import styled from '@emotion/styled'
import { Avatar, Shield, Money } from '@ticketswap/comets'
import priceCap from '~/utils/priceCap'

const Container = styled.div`
  margin-top: ${space[16]};
  display: grid;
  grid-gap: ${space[16]};
  grid-template-columns: repeat(2, 1fr);

  @media ${device.tablet} {
    margin-top: ${space[24]};
    grid-gap: ${space[32]};
    grid-template-columns: repeat(3, 1fr);
  }

  & > div:nth-of-type(3) {
    display: none;

    @media ${device.tablet} {
      display: flex;
    }
  }
`

const Factor = styled.div`
  display: flex;

  p,
  span {
    color: ${color.nova};

    [data-theme='dark'] & {
      color: ${color.space};
    }
  }

  & > span:first-of-type {
    margin-right: ${space[8]};
  }

  @media ${device.tablet} {
    & > span {
      min-width: 24px;
      min-height: 24px;
    }
  }
`

const TrustFactors = ({ t }) => (
  <Container>
    <Factor>
      <Money size={16} />
      <SmallText as="p">
        {t('home:trustFactors.priceCap', {
          priceCap: priceCap(),
        })}
      </SmallText>
    </Factor>
    <Factor>
      <Avatar size={16} />
      <SmallText as="p">{t('home:trustFactors.userCount')}</SmallText>
    </Factor>
    <Factor>
      <Shield size={16} />
      <SmallText as="p">{t('home:trustFactors.partners')}</SmallText>
    </Factor>
  </Container>
)

TrustFactors.propTypes = {
  t: PropTypes.func.isRequired,
}

export default TrustFactors
